var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"team-member"},[_c('div',{staticClass:"wrapper",style:('max-width: ' + _vm.blok.maxwidth + 'px')},[_c('img',{attrs:{"src":_vm.blok.image}})]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.blok.name))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.blok.job))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67cd9f96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Team.vue
// module id = null
// module chunks = 